// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4361":"97446f7834379603","8775":"340d57eadb634ca6"}[chunkId] + ".js";
};